/* eslint-disable radix */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../axiosConfig';

const orderFetchSourceTrendQuery = (startTime, endTime, groupBy) => ({
  logQuery:
    'message:"Fetching order By calling OMS for order Id" OR message:"Fetching Order Summary Object from"',
  startTime,
  endTime,
  groupBy,
  regExs: ['.*OMS.*', '.*DB.*', '.*Cache.*'],
  labels: ['OMS', 'DB', 'Cache'],
});

const getQueryTrendLine = async ({
  logQuery,
  startTime,
  endTime,
  groupBy,
  regExs,
  labels,
}) => {
  const apiCall = await apiConfig.post('/monitoring-dashboard/log-trend-line', {
    startTime,
    endTime,
    groupBy,
    logQuery,
    groups: regExs,
  });
  const trend = await apiCall.data.data;
  Object.keys(trend).forEach((key) => {
    const newkey = labels[parseInt(key)];
    trend[newkey] = trend[key];
    delete trend[key];
  });
  return trend;
};

const getQueryLogCount = async ({
  logQuery,
  startTime,
  endTime,
  groupBy,
  regExs,
  labels,
}) => {
  const apiCall = await apiConfig.post('/monitoring-dashboard/log-count', {
    startTime,
    endTime,
    groupBy,
    logQuery,
    groups: regExs,
  });
  const trend = await apiCall.data.data;
  Object.keys(trend).forEach((key) => {
    const newkey = labels[parseInt(key)];
    trend[newkey] = trend[key];
    delete trend[key];
  });
  return trend;
};

const LOG_GROUPS_LABELS = [
  'Food',
  'FlightOTA',
  'Hotel',
  'AAXpress',
  'Beauty',
  'OurFresh',
  'Activities',
  'Deal',
  'Health',
  'Shop',
  'AARide',
  'ExtendedFlightOTA',
  'Insurance',
  'IKHLAS',
  'SettlementAARide',
];
const LOG_GROUPS_CURRENCY_LABELS = [
  'MYR',
  'PHP',
  'IDR',
  'USD',
  'EUR',
  'TBH',
  'GBP',
  'AUD',
  'SGD',
  'INR',
  'Others',
];

const LOG_GROUPS_REGEX = [
  '.*Food.*',
  '.*[^d]FlightOTA.*',
  '.*Hotel.*',
  '.*AAXpress.*',
  '.*Beauty.*',
  '.*OurFresh.*',
  '.*Activities.*',
  '.*Deal.*',
  '.*Health.*',
  '.*Shop.*',
  '.*AARide.*',
  '.*ExtendedFlightOTA.*',
  '.*Insurance.*',
  '.*IKHLAS.*',
  '.*SettlementAARide.*',
];
const LOG_GROUPS_CURRENCY_REGEX = [
  '.*currency=MYR,.*',
  '.*currency=PHP,.*',
  '.*currency=IDR,.*',
  '.*currency=USD,.*',
  '.*currency=EUR,.*',
  '.*currency=THB,.*',
  '.*currency=GBP,.*',
  '.*currency=AUD,.*',
  '.*currency=SGD,.*',
  '.*currency=INR,.*',
  '.*',
];

export const getMainDashboard = createAsyncThunk(
  'monitoring-dashboard/getMainDashboard',
  async () => {
    const endTime = new Date().getTime();
    const startTime = endTime - 24 * 60 * 60 * 1000;
    const groupBy = 5 * 60 * 1000;
    const response = await apiConfig.get(
      `/monitoring-dashboard/main?startTime=${startTime}&endTime=${endTime}&groupBy=${groupBy}`,
    );
    const data = await response.data;
    const sucessfulOrderTrendCall = await apiConfig.post(
      '/monitoring-dashboard/log-trend-line',
      {
        startTime,
        endTime,
        groupBy,
        logQuery:
          'message:("Successfully Published The Payment Transaction For The Order" AND message:"status=SUCCESS") OR (message:"Successfully Published The Auto Debit Payment Transaction For The Order" AND message:"status=SUCCESS")',
        groups: [],
      },
    );
    data.data.sucessfulOrderTrend = await sucessfulOrderTrendCall.data.data[
      '0'
    ];
    const sucessfulOrderTrendByLOBCall = await apiConfig.post(
      '/monitoring-dashboard/log-trend-line',
      {
        startTime,
        endTime,
        groupBy,
        logQuery:
          'message:("Successfully Published The Payment Transaction For The Order" AND message:"status=SUCCESS") OR (message:"Successfully Published The Auto Debit Payment Transaction For The Order" AND message:"status=SUCCESS")',
        groups: LOG_GROUPS_REGEX,
      },
    );
    data.data.sucessfulOrderTrendByLOB = await sucessfulOrderTrendByLOBCall.data
      .data;
    Object.keys(data.data.sucessfulOrderTrendByLOB).forEach((key) => {
      const newkey = LOG_GROUPS_LABELS[parseInt(key)];
      data.data.sucessfulOrderTrendByLOB[newkey] =
        data.data.sucessfulOrderTrendByLOB[key];
      delete data.data.sucessfulOrderTrendByLOB[key];
    });
    data.data.sucessfullOrdersByCurrency = {};

    /* eslint-disable-next-line no-restricted-syntax -- @TODO improve this */
    for (const lob of ['FlightOTA', 'Food', 'Hotel', 'Deal', 'AARide']) {
      // eslint-disable-next-line no-await-in-loop
      const apiCall = await apiConfig.post('/monitoring-dashboard/log-count', {
        startTime,
        endTime,
        groupBy,
        logQuery: `message:("Successfully Published The Payment Transaction For The Order" AND message:"status=SUCCESS" AND "OrderType=${lob}") OR (message:"Successfully Published The Auto Debit Payment Transaction For The Order" AND message:"status=SUCCESS" AND "OrderType=${lob}")`,
        groups: LOG_GROUPS_CURRENCY_REGEX,
      });

      // @TODO check why need to do await again here 🤔
      // eslint-disable-next-line no-await-in-loop
      data.data.sucessfullOrdersByCurrency[lob] = await apiCall.data.data;

      Object.keys(data.data.sucessfullOrdersByCurrency[lob]).forEach((key) => {
        const newkey = LOG_GROUPS_CURRENCY_LABELS[parseInt(key)];
        data.data.sucessfullOrdersByCurrency[lob][newkey] =
          data.data.sucessfullOrdersByCurrency[lob][key];
        delete data.data.sucessfullOrdersByCurrency[lob][key];
      });
    }

    data.data.orderFetchSourceTrend = await getQueryTrendLine(
      orderFetchSourceTrendQuery(
        endTime - 1 * 60 * 60 * 1000,
        endTime,
        15 * 1000,
      ),
    );
    return data;
  },
);

export const getLoadBalancerDashboard = createAsyncThunk(
  'monitoring-dashboard/load-balancer',
  async () => {
    const response = await apiConfig.get('/monitoring-dashboard/load-balancer');
    const data = await response.data;
    return data;
  },
);

export const getLoadBalancerLogs = createAsyncThunk(
  'monitoring-dashboard/load-balancer-logs',
  async () => {
    const response = await apiConfig.get(
      '/monitoring-dashboard/load-balancer-logs',
    );
    const data = await response.data;
    return data;
  },
);

export const getHealthChecks = createAsyncThunk(
  'monitoring-dashboard/hcheck',
  async () => {
    const response = await apiConfig.get('/payments/hcheck/get', {
      headers: { action: 1 },
    });
    const data = await response.data;
    return data;
  },
);

export const loadQueryTrendLine = createAsyncThunk(
  'monitoring-dashboard/lucene-trend-line',
  async ({
    attribute,
    logQuery,
    startTime,
    endTime,
    groupBy,
    regExs,
    labels,
  }) => {
    const data = await getQueryTrendLine(
      logQuery,
      startTime,
      endTime,
      groupBy,
      regExs,
      labels,
    );
    return { attribute, data };
  },
);

export const loadQueryPieData = createAsyncThunk(
  'monitoring-dashboard/lucene-log-count',
  async ({
    attribute,
    logQuery,
    startTime,
    endTime,
    groupBy,
    regExs,
    labels,
  }) => {
    const data = await getQueryLogCount(
      logQuery,
      startTime,
      endTime,
      groupBy,
      regExs,
      labels,
    );
    return { attribute, data };
  },
);

const monitoringDashboardSlice = createSlice({
  name: 'monitoring-dashboard',
  initialState: {
    mainDashboard: {},
    loadBalancerDashboard: {},
    loadBalancerLogs: {},
    healthChecks: [],
  },
  reducers: {},
  extraReducers: {
    [getMainDashboard.fulfilled]: (state, action) => {
      state.status = 'done';
      if (!action.payload || !action.payload.data) {
        return;
      }
      state.mainDashboard = { ...action.payload.data };
    },
    [loadQueryTrendLine.fulfilled]: (state, action) => {
      state.status = 'done';
      if (!action.payload || !action.payload.data) {
        return;
      }
      state.mainDashboard[action.payload.attribute] = {
        ...action.payload.data,
      };
    },
    [loadQueryPieData.fulfilled]: (state, action) => {
      state.status = 'done';
      if (!action.payload || !action.payload.data) {
        return;
      }
      state.mainDashboard[action.payload.attribute] = {
        ...action.payload.data,
      };
    },

    [getLoadBalancerDashboard.fulfilled]: (state, action) => {
      state.status = 'done';
      if (!action.payload || !action.payload.data) {
        return;
      }
      state.loadBalancerDashboard = { ...action.payload.data };
    },
    [getLoadBalancerLogs.fulfilled]: (state, action) => {
      state.status = 'done';
      if (!action.payload || !action.payload.data) {
        return;
      }
      state.loadBalancerLogs = { ...action.payload.data };
    },
    [getHealthChecks.fulfilled]: (state, action) => {
      state.status = 'done';
      if (!action.payload || !action.payload.data) {
        return;
      }
      state.healthChecks = action.payload.data;
    },
  },
});

export const monitoringDashboarActions = monitoringDashboardSlice.actions;
export default monitoringDashboardSlice.reducer;
